import type { PopperProps } from '@mui/material/Popper';
import { Popper } from '@mui/material';
import { forwardRef } from 'react';
import { lensSpacingPx, useOnboardingLens } from './onboardingLens';

export interface OnboardingFormFieldPopperProps extends PopperProps {
  overlayZIndex?: number;
}

/** Popper for Atlas form dropdowns — bottom-start anchor, small gap, flip on zoom. */
export const OnboardingFormFieldPopper = forwardRef<HTMLDivElement, OnboardingFormFieldPopperProps>(
  function OnboardingFormFieldPopper({ overlayZIndex, style, sx, ...props }, ref) {
    const { tokens } = useOnboardingLens();
    const dropdownGap = lensSpacingPx(tokens, '1');

    return (
      <Popper
        ref={ref}
        {...props}
        disablePortal={false}
        placement="bottom-start"
        modifiers={[
          {
            name: 'offset',
            options: { offset: [0, dropdownGap] },
          },
          // Flip stays enabled so zoomed viewports can open the list above the field
          // when there isn't room below — same behaviour as Change image Tags.
        ] as PopperProps['modifiers']}
        style={{ ...style, ...(overlayZIndex != null ? { zIndex: overlayZIndex } : {}) }}
        sx={{ ...sx, ...(overlayZIndex != null ? { zIndex: overlayZIndex } : {}) }}
      />
    );
  },
);
